let storage = sessionStorage;

export function SaveInStorage(prop,val){
	checkStorage();

	let cStorage = !!storage.vessi && storage.vessi !== 'false' ? JSON.parse(storage.vessi): {};
	
	cStorage[prop] = val;
	storage.vessi = JSON.stringify( cStorage );
}

export function GetFromStorage(prop){
	checkStorage();
	let stor = !!storage.vessi && storage.vessi !== 'false' ? JSON.parse(storage.vessi): {};
	return stor[prop];
}

export function RemoveAttrInStorage(attr){
	checkStorage();
	let cStorage = !!storage.vessi ? JSON.parse(storage.vessi): false;
	if( !!cStorage ){
		delete cStorage[attr];
		clrStorage();
		cStorage = Object.keys(cStorage).length > 0? cStorage:{};
 		storage.vessi = JSON.stringify( cStorage );
		return true;
	}else{
		return false;
	}
};

let clrStorage = function(){
	return	delete storage.vessi;
}

export let ClearStorage = clrStorage;

export function ChangeStorage(newStorage=sessionStorage){
	storage = newStorage;
};

function checkStorage(){
	try{
		let cStorage = JSON.parse(storage.vessi);
		if(typeof cStorage !== 'object')	throw 'No es objeto';
		cStorage.checking = 'checking';
		delete cStorage.checking;
	}catch(err){
		
		storage.vessi = JSON.stringify( {} );
	}
}

export const tiposDte = {
	30: 'Factura',
	32: 'Factura de ventas y servicios no afectos o exentos de IVA',
	33: 'Factura electrónica',
	34: 'Factura no afecta o exenta electrónica',
	35: 'Boleta',
	38: 'Boleta exenta',
	39: 'Boleta electrónica',
	40: 'Liquidación factura',
	41: 'Boleta exenta electrónica',
	43: 'Liquidación factura electrónica',
	45: 'Factura de compra',
	46: 'Factura de compra electrónica',
	48: 'Pago electrónico',
	50: 'Guía de despacho',
	52: 'Guía de despacho electrónica',
	55: 'Nota de débito',
	56: 'Nota de débito electrónica',
	60: 'Nota de crédito',
	61: 'Nota de crédito electrónica',
	103: 'Liquidación',
	110: 'Factura de exportación electrónica',
	111: 'Nota de débito de exportación electrónica',
	112: 'Nota de crédito de exportación electrónica'
};

export const diccionarioDte = {
	30: 'Factura',
	32: 'Factura de ventas y servicios no afectos o exentos de IVA',
	33: 'Factura electrónica',
	34: 'Factura no afecta o exenta electrónica',
	35: 'Boleta',
	38: 'Boleta exenta',
	39: 'Afecta',
	40: 'Liquidación factura',
	41: 'Exenta',
	43: 'Liquidación factura electrónica',
	45: 'Factura de compra',
	46: 'Factura de compra electrónica',
	48: 'Pago electrónico',
	50: 'Guía de despacho',
	52: 'Guía de despacho electrónica',
	55: 'Nota de débito',
	56: 'Nota de débito electrónica',
	60: 'Nota de crédito',
	61: 'Nota de crédito electrónica',
	103: 'Liquidación',
	110: 'Factura de exportación electrónica',
	111: 'Nota de débito de exportación electrónica',
	112: 'Nota de crédito de exportación electrónica'
};